<div class="container" @fadeIn>
    <div fxLayout="row wrap" class="header m-b-10">
        <div fxFlex="93" fxLayoutAlign="center center">
            <span class="header-text">Templates</span>
        </div>
        <div class="pointer" (click)="onClosePopup()">
            <mat-icon>clear</mat-icon>
        </div>
    </div>
    <div fxLayout="row wrap" *ngIf="isSkeleton">
        <mat-card fxFlex="30" class="thumbnail-container skeleton m-r-5-p" *ngFor="let item of templates">
            <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '10', height: '200px' }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" [theme]="{height: '30px', top: '-10px', 'margin-bottom': '-20px'}">
            </ngx-skeleton-loader>
        </mat-card>
    </div>
    <div fxLayout="row wrap" *ngIf="!isSkeleton" id="printSection">
        <mat-card fxFlex="30" class="thumbnail-container template m-r-5-p" *ngFor="let template of templates; let i=index">
            <button class="printBtn" (click)="onPrintClick(template, i)">
                <div>
                    <img [src]="template.src" width="100%" class="pointer">
                </div>
                <div class="p-15 filename-section" fxLayoutAlign="center center">
                    <mat-icon class="m-r-5">description</mat-icon>
                    <div class="filename">{{template.name}}</div>
                </div>
            </button>
        </mat-card>
        <div *ngFor="let template of templates; let i=index">
            <button *ngIf="template.loadTemplate" [hidden]="true" [printSectionId]="getPrintTemplateId(i)" [attr.id]="getPrintTemplateId(i)" ngxPrint>
                <app-template (onLoad)="onLoad()" [htmlText]="template.htmlText"></app-template>
            </button>
        </div>
    </div>
</div>